import React from "react";

export default function AgeMeter({ minAge = 18, maxAge = 35, minLimit = 18, maxLimit = 70, onChange }) {
  const MIN_LIMIT = minLimit;
  const MAX_LIMIT = maxLimit;

  const handleMinChange = (e) => {
    const val = Math.min(Math.max(parseInt(e.target.value, 10) || MIN_LIMIT, MIN_LIMIT), maxAge - 1);
    onChange(val, maxAge);
  };

  const handleMaxChange = (e) => {
    const val = Math.min(Math.max(parseInt(e.target.value, 10) || MAX_LIMIT, minAge + 1), MAX_LIMIT);
    onChange(minAge, val);
  };

  // Calculate track fill percentages for visual meter
  const minPercent = Math.max(0, Math.min(100, ((minAge - MIN_LIMIT) / (MAX_LIMIT - MIN_LIMIT)) * 100));
  const maxPercent = Math.max(0, Math.min(100, ((maxAge - MIN_LIMIT) / (MAX_LIMIT - MIN_LIMIT)) * 100));

  // When both handles sit at the far right, the min handle must be on top or it can't be dragged back.
  const minOnTop = minPercent > 90;

  return (
    <div className="inline-age-meter-box w-100">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span className="inline-age-val">{minAge} - {maxAge} Yrs</span>
      </div>

      <div className="single-dual-slider-wrap">
        <div className="single-meter-track">
          <div
            className="single-meter-fill"
            style={{
              left: `${minPercent}%`,
              width: `${maxPercent - minPercent}%`,
            }}
          />
        </div>
        <input
          type="range"
          min={MIN_LIMIT}
          max={MAX_LIMIT - 1}
          value={Math.max(minAge, MIN_LIMIT)}
          onChange={handleMinChange}
          className="dual-range-input dual-range-min"
          style={minOnTop ? { zIndex: 5 } : undefined}
          aria-label="Minimum Age"
        />
        <input
          type="range"
          min={MIN_LIMIT + 1}
          max={MAX_LIMIT}
          value={maxAge}
          onChange={handleMaxChange}
          className="dual-range-input dual-range-max"
          aria-label="Maximum Age"
        />
      </div>
    </div>
  );
}
